import { FC } from 'react';
import styles from './ComplianceGauge.module.css';

interface ComplianceGaugeProps {
    value: number;
    max: number;
    label: string;
    subLabel: string;
    color?: string;
    size?: number;
}

const ComplianceGauge: FC<ComplianceGaugeProps> = ({
    value,
    max,
    label,
    subLabel,
    color = 'var(--brand-action)',
    size = 180,
}) => {
    const radius = 70;
    const circumference = Math.PI * radius; // Semi-circle
    const percentage = Math.min(100, (value / max) * 100);
    const strokeDashoffset = circumference - (percentage / 100) * circumference;

    return (
        <div className={styles.gaugeContainer} style={{ width: size, height: size / 1.5 }}>
            <svg width={size} height={size / 1.5} viewBox="0 0 160 100">
                {/* Background track */}
                <path
                    d="M 10 90 A 70 70 0 0 1 150 90"
                    fill="none"
                    stroke="#e2e8f0"
                    strokeWidth="12"
                    strokeLinecap="round"
                />
                {/* Progress track */}
                <path
                    d="M 10 90 A 70 70 0 0 1 150 90"
                    fill="none"
                    stroke={color}
                    strokeWidth="12"
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                    className={styles.gaugeProgress}
                />
            </svg>
            <div className={styles.gaugeInfo}>
                <span className={styles.gaugeLabel}>{label}</span>
                <span className={styles.gaugeSubLabel}>{subLabel}</span>
            </div>
        </div>
    );
};

export default ComplianceGauge;
